<template>
  <v-container>


    <v-row>
      <v-breadcrumbs class="pa-0 text--text caption">
        <router-link
        class="rlink-hover text--text"
        style="text-decoration: none;"
        :to="{ path: '/inventory-tx/'}">
          <span class="ml-1">Inventory transactions</span>
        </router-link>
        <span class="pl-2 pr-2">/</span>
        <v-breadcrumbs-item disabled>
          {{ id }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </v-row>


    <v-row class="mt-4 title mb-4">
      <v-avatar color="" size="36px" class="mr-4" style="background: linear-gradient(30deg, #EF9958, #DB4572);">
        <v-icon color="white">mdi-timeline-text-outline</v-icon>
      </v-avatar>
      Inventory Transaction {{ id }}

      <v-spacer></v-spacer>

      
      <t-item-diff v-if="$store.state.settings.debugMode" :item1="lastSave" :item2="merged">
        <v-layout 
        slot="item1Header"
        align-center class="subheading font-weight-bold pl-2 crx-toolbar">
          Last save
        </v-layout>
        <v-layout 
        slot="item2Header"
        align-center class="subheading font-weight-bold pl-2 crx-toolbar">
          LIVE
        </v-layout>
      </t-item-diff>
      

      <v-slide-x-transition
      mode="out-in">
        <v-btn
        v-if="isDirty"
        text
        outlined
        key="save2"
        width="8em"
        :loading="saving"

        @click="save">
          <v-icon color="color1">mdi-cloud-upload-outline</v-icon>
          <div class="ml-1">
            Save
          </div>
        </v-btn>

        <v-btn
        v-else
        key="save1"
        text
        width="8em"
        class="font-weight-regular"
        disabled>
          <v-icon small>mdi-shield-check-outline</v-icon>
          Saved
        </v-btn>
        
        
      </v-slide-x-transition>
    </v-row>

    <v-row>
      <v-col md="6">
      <v-card class="mr-2">

        <div class="title pa-4">
          TX info
        </div>

        <div class="c-hr"></div>

        <div class="pa-4">

          <v-row class="align-center">
            <v-col md="3">
              <div class="label">Category:</div>
            </v-col>
            <v-col md="9">
              <c-select-inv-tx-category :selectedID.sync="formData.category_id" class="crx-box-input"></c-select-inv-tx-category>
            </v-col>
          </v-row>

          <v-row class="align-center">
            <v-col md="3">
              <div class="label">Date:</div>
            </v-col>
            <v-col md="9">
              <!-- <c-date :date.sync="formData.date" class="crx-box-input"></c-date> -->
              <c-datetime :date.sync="formData.date" class="crx-box-input"></c-datetime>
            </v-col>
          </v-row>

        </div>
      
      </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="12">

        <v-card class="" style="overflow: hidden;">

          <v-row class="align-center pa-2 pl-3 border-b--thin">
            <transition
            name="slide-x-reverse-transition"
            mode="out-in">

              <!-- ITEMS -->
              <div 
              v-if="selectedCount === 0"
              key="1"
              class="c-flex-r align-center subheading">

                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectAll">
                      <v-list-item-title>Select all</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn
                text
                outlined
                class="mr-2 ml-2"
                @click="addItem">
                  <v-icon>add</v-icon>
                  <div class="ml-1">
                    Add item
                  </div>
                </v-btn>

              </div>

              <!-- selected count -->
              <div v-if="selectedCount > 0"
              key="2"
              class="c-flex-r align-center subheading">
                <v-btn
                icon
                class=""
                @click="selected = {}">
                  <v-icon color="color1">close</v-icon>
                </v-btn>
                <div class="text-sans font-weight-bold">
                  <span>&nbsp;{{ selectedCount }}</span>
                  selected 
                </div>
                <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
                <span class="icon--text ml-2">|</span>
                <v-btn 
                icon
                @click="onDelete">
                  <v-icon>delete_outline</v-icon>
                </v-btn>
                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectAll">
                      <v-list-item-title>Select all</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </transition>
          </v-row>

          <table :class="['final-table th-no-padding lines-b full-width', {'hover pointer': selectedCount !== 0}]">
            <colgroup ref="colgroup1">
              <col width="10px">
              <col width="8px">
              <col width="10px">
            </colgroup>
            <tr>
              <c-table-header
              title="Name"
              code="name"
              class="sticky"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              title="RID"
              code="rid"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              title="Quantity"
              code="quantity"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
            </tr>
            <tr>
              <td class="sticky">
                <v-text-field
                v-model="filters.search.id"
                placeholder="Search..."
                hide-details
                class="crx-box-input"
                clearable
                color="color1"
                solo>
                </v-text-field>
              </td>
              <td></td>
              <td></td>
            </tr>

            <list-row 
            v-for="item in paginatedArray"
            :vmode="0"
            :key="item.tempID" 
            :item="item"
            :reserved="(savedInputs.find(row => row.id === item.id) || {}).quantity"
            :inventoryView="inventoryView"
            :mergeMap="mergeMap"
            :selected="selected"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)">
            </list-row>

          </table>

          <!-- PAGINATION -->
          <c-pagination-client
          :page="page"
          :paginationLength="paginationLength"
          :paginatedArray="paginatedArray"
          :rowsPerPage.sync="rowsPerPage"
          @updatePageNumber="updatePageNumber"
          @goToFirstPage="goToFirstPage"
          @goToPreviousPage="goToPreviousPage"
          @goToNextPage="goToNextPage"
          @goToLastPage="goToLastPage">
          </c-pagination-client>
          <!-- PAGINATION -->

        </v-card>

      </v-col>
    </v-row>

    <!-- LOG AREA -->
    <!--

      <v-card class="ma-4 caption unselectable">
        Inventory View:
        <json-viewer :item="inventoryView"></json-viewer>
      </v-card>

      <v-row no-gutters>
        <v-col sm="4">
          <v-card class="ma-1 caption unselectable">
            Saved Inputs:
            <json-viewer :item="savedInputs"></json-viewer>
          </v-card>
        </v-col>
        <v-col sm="4">
          <v-card class="ma-1 caption unselectable">
            Merge Map:
            <json-viewer :item="mergeMap"></json-viewer>
          </v-card>
        </v-col>
        <v-col sm="4">
          <v-card class="ma-1 caption unselectable">
            Inventory Map:
            <json-viewer :item="inventoryMap"></json-viewer>
          </v-card>
        </v-col>

      </v-row>

    -->
    <!-- LOG AREA -->


    <!-- DIALOGS -->
    <select-inventory-item-dialog ref="selectItemDialog" :exceptions="inventoryExceptions">
    </select-inventory-item-dialog>

  </v-container>
</template>

<script>
import Vue from 'vue'
import ListRow from './list-row'
import ListController from '@/mixins/ListController'
import SelectInventoryItemDialog from '@/components/dialogs/select-inv-item/Dialog'
import InventoryHelper from '@/js/shared/inventory.js'
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: {
    id: null
  },
  mixins: [ListController],
  components: {
    ListRow,
    SelectInventoryItemDialog,
    JsonViewer
  },
  data () {
    return {
      formData: {
        category_id: null,
        date: null
      },
      lastSave: {
        category_id: null,
        date: null,
        rows: []
      },
      filters: {
        rowsPerPage: 10,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      page: 0,
      saving: false,
      inventoryMap: {},
      debitMap: {},
      mergeMap: {},
      savedInputs: []
    }
  },
  computed: {
    inventoryExceptions () {
      return this.items.map(item => {
        if (item.inventory_id) {
          return item.inventory_id
        } else {
          return this.mergeMap[item.id]
        }
      })
    },
    isDirty () {
      return !_.isEqual(this.lastSave, this.merged)
    },
    merged () {
      var merged = {
        category_id: this.formData.category_id,
        date: this.formData.date,
        rows: JSON.parse(JSON.stringify(this.items)),
      }
      return merged
    },
    inventorySet () {
      return [...new Set(this.items.map(item => item.inventory_item_id))]
    },
    inventoryView () {
      var inventoryArray = Object.values(this.inventoryMap).flat(1)
      return InventoryHelper.mergeDebitsBackToInventory(inventoryArray, this.savedInputs, this.mergeMap).reduce((a, i) => {
        if (a[i.inventory_item_id]) {
          a[i.inventory_item_id].push(i)
        } else {
          a[i.inventory_item_id] = [i]
        }
        return a
      }, {})
    },
  },
  watch: {
    inventorySet (nv) {
      Object.keys(this.debitMap).forEach(_id => {
        var id = parseInt(_id)
        if (nv.indexOf(id) === -1) {
          Vue.delete(this.debitMap, id)
        }
      })
      this.fetchInventory(this.inventorySet)
        .then(map => {
          this.inventoryMap = map
        })
    },
  },
  methods: {
    convertDBInputsToDebitMaps (inputs, mergeMap) {
      var rmMap = {}
      inputs.forEach(input => {
        if (!rmMap[input.inventory_item_id]) {
          rmMap[input.inventory_item_id] = {}
        }
        var invMergeId = mergeMap[input.id]
        var currentDebit = rmMap[input.inventory_item_id][invMergeId] || 0
        Vue.set(rmMap[input.inventory_item_id], invMergeId, currentDebit + input.quantity)
      })
      return rmMap
    },
    fetchInventory (_set) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.$axios.post(`/inventory/inventory-item-id/multiple`, _set)
          .then(response => {
            resolve(response.data.map)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    addItem () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          var copy = JSON.parse(JSON.stringify(selectedItem))
          // copy.quantity_available = copy.quantity
          copy.quantity = 0
          copy.inventory_id = copy.id
          copy.id = undefined
          this.items.push(copy)

        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      }
    },
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' item' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete()
        }
      })
    },
    save () {
      this.saveAxios()
      .then(() => {
        this.loadAPI()
      })
      .catch(error => this.$root.$errorSnackbar(error))
    },
    saveAxios () {
      return new Promise((resolve, reject) => {
        var prunedRows = this.items.map(item => {
          return {
            id: item.id,
            inventory_id: item.inventory_id,
            inventory_item_id: item.inventory_item_id,
            quantity: item.quantity,
            archive_id: item.archive_id
          }
        })
        let data = {
          category_id: this.formData.category_id,
          date: this.formData.date,
          rows: JSON.parse(JSON.stringify(prunedRows)),
          mergeMap: this.mergeMap || {}
        }
        this.saving = true
        this.$axios.patch('inventory-tx/' + this.id,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.$axios.get(`/inventory-tx/${this.id}`)
          .then(response => {
            var hrend = response.data.execution_time
            var rows = response.data.rows
            this.items = rows

            this.formData.date = response.data.details.date_created
            this.formData.category_id = response.data.details.category_id

            // nextTick because of rows getting .tempID and .ordering properties after this is called
            this.$nextTick(() => {
              this.lastSave.date = response.data.details.date_created
              this.lastSave.category_id = response.data.details.category_id
              this.lastSave.rows = JSON.parse(JSON.stringify(this.items))
            })

            this.savedInputs = JSON.parse(JSON.stringify(rows))

            var invSet = [...new Set(this.items.map(item => item.inventory_item_id))]
            return this.$axios.post(`/inventory/inventory-item-id/multiple`, invSet)
          })
          .then(response => {
            var invMap = response.data.map
            var inventoryArray = Object.values(invMap).flat(1)
            this.mergeMap = InventoryHelper.mergeMapMultiple(inventoryArray, this.savedInputs)
            this.debitMap = this.convertDBInputsToDebitMaps(this.savedInputs, this.mergeMap)
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>